// @flow
import api from 'tim-api';
import { role as roleEndPont } from 'endPoints';

export const state = {
  roles: [],
  role: []
};

export const getters = {
  roles: (state: Object) => state.roles,
  role: (state: Object) => state.role
};

export const mutations = {
  SET_ROLES(state: Object, roles: Array<Object>) {
    state.roles = roles;
  },
  SET_ROLE(state: Object, role: Array<Object>) {
    state.role = role;
  }

};

export const actions = {
  fetchRoles({ commit }: Action) {
    return api.get(`${roleEndPont}/web`).then(({ data }) => {
      commit('SET_ROLES', data.data);
    });
  },
  fetchRoleBySlug({ commit }: Action, slug: string) {
    return api.get(`${roleEndPont}/web/${slug}`).then(({ data }) => {
      commit('SET_ROLE', data.data);
    });
  },
  fetchRolesWithWebPermissions({ commit }: Action) {
    return api.get(`${roleEndPont}/web`).then(({ data }) => {
      commit('SET_ROLE', data.data);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
